import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { I18nRoutes, RouteName } from './types';
import { useCurrentLanguage } from '../i18n';

const ClientRoutesContext = React.createContext<I18nRoutes | null>(null);

type Props = {
  publicRouteConfig: any;
  privateRouteConfig: any;
  children: React.ReactNode;
};

const ClientRoutesProvider: FC<Props> = ({ publicRouteConfig, privateRouteConfig, children }) => {
  const { t } = useTranslation();
  const currentLanguage = useCurrentLanguage();

  const allRouteKeys = [
    ...Object.keys(publicRouteConfig),
    ...Object.keys(privateRouteConfig),
  ] as RouteName[];

  const routes = allRouteKeys
    .map((key) => ({ key, value: `/${currentLanguage}/${t('routes.' + key)}` }))
    .reduce((acc, { key, value }) => ({ ...acc, [key]: value }), {} as I18nRoutes);

  return <ClientRoutesContext.Provider value={routes}>{children}</ClientRoutesContext.Provider>;
};

export { ClientRoutesContext };
export default ClientRoutesProvider;
